module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAe0lEQVR42u3aoQ0AIAxFwY7DBuy/E74kLIAA96/JsxWnSGh1dyVXAAAAAAAAAAAAAACEA6wx+6XbvO7/HQAAAAAAAAAAAAAAAAAAAADglDYAAAAAAAAAAA8hAAAAAAAAAAAAAAAAAAAAIPlfwKUoAAAAAAAAAAAAAAA5bQ9OWFO8cyOzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Denmark.png
// module id = lGAZ
// module chunks = 0 62 63